<div #iconTemplate class="lg:hidden flex-row content-center items-center justify-center align-center h-full">
  <p-button (click)="iconMenu.toggle($event)" [text]="true" class="h-full" styleClass="!text-link h-full">
    <i class="text-2xl !text-link">{{ defaultIcon.Menu.substring(3) }}</i>
  </p-button>
  <p-tieredmenu #iconMenu [model]="model" [popup]="true" appendTo="body" />
</div>
<div
  #barTemplate
  class="hidden lg:inline-flex flex-row content-center items-center justify-center align-center h-full"
  [class.gap-0]="gap === 0"
  [class.gap-1]="gap === 1"
  [class.gap-2]="gap === 2 || gap === undefined"
>
  @for (item of model; track $index) {
    @if (item.visible === false) {
      <!--invisible-->
    } @else if (item.separator) {
      <p-divider />
    } @else if (item.items) {
      <p-button
        (onClick)="menu.toggle($event)"
        [text]="true"
        [class.anti-gap]="!item.label"
        class="h-full"
        styleClass="h-full"
        size="small"
        [disabled]="item.disabled"
      >
        <div class="text-link inline-flex flex-row content-center items-center">
          @if (item.icon) {
            <i>{{ item.icon.substring(3) }}</i>
          }
          {{ item.label }}<i class="text-2xl">{{ defaultIcon.DropDown.substring(3) }}</i>
        </div>
      </p-button>
      <p-tieredMenu #menu [model]="item.items" [popup]="true" appendTo="body" />
    } @else {
      <p-button
        [icon]="item.icon"
        [label]="item.label"
        (onClick)="onItemClick($event, item)"
        [text]="true"
        styleClass="!text-link"
        size="small"
        [disabled]="item.disabled"
      />
    }
  }
</div>
